import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";

import { BaseComponent, ContentService, environment, ProductService, UserService, WindowService } from "@mypxplat/xplat/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { AppService } from "@mypxplat/xplat/web/core";
import { FileUploader } from "ng2-file-upload";
import { Router } from "@angular/router";
import { RegisterProductComponent } from "../register-product/register-product.component";

@Component({
  selector: "fui-missing-fender-serial",
  templateUrl: "missing-fender-serial.component.html",
  standalone: false,
})
export class MissingFenderSerialComponent extends BaseComponent implements OnInit {
  @Output() inelligibleProductEntered: EventEmitter<any> = new EventEmitter();
  @Input() serial: string = "";
  public sku: string = "";
  public productName: string = "";
  public shopLink: string = "";
  public serialImageUploader: FileUploader;
  public bodyImageUploader: FileUploader;
  public uploadingComplete: boolean = false;
  public uploadingFile: any;
  public fileResponse: any;
  public hoveringFileDrops: any = {
    serial: false,
    body: false,
  };
  public foundSku: any;
  public skuNotFound: boolean = false;
  public searchingSku: boolean = false;
  public unknownSku: boolean = false;
  public fileUploadProgress: any = {
    serialImage: null,
    bodyImage: null,
  };
  public submitArgs: any = {};
  public saving: boolean = false;
  public savingComplete: boolean = false;
  public category: string = "electric_guitars";
  constructor(
    userService: UserService,
    public activeModal: NgbActiveModal,
    public appService: AppService,
    public productService: ProductService,
    public contentService: ContentService,
    private _router: Router,
    private _win: WindowService
  ) {
    super(userService);
  }

  ngOnInit() {
    this.setupSerialImageUploader();
    this.setupBodyImageUploader();
  }

  public selectedSerialImageFile: any;
  public displaySerialImage: any;
  setupSerialImageUploader() {
    this.serialImageUploader = new FileUploader({
      isHTML5: true,
      method: "PUT",
      queueLimit: 1,
      autoUpload: false,
      disableMultipart: true,
      url: "",
    });
    this.serialImageUploader.onProgressAll = (progress: any) => {
      if (this.contentService.uploadSession.filesMap[this.selectedSerialImageFile.file.name]) {
        this.contentService.uploadSession.filesMap[this.selectedSerialImageFile.file.name].progress = progress;
      }
      this.fileUploadProgress.serialImage = progress < 100 ? progress : null;
    };

    this.serialImageUploader.onErrorItem = (error: any) => {
      alert("There was an error uploading the serial image, please try again.");
      this.serialImageUploader.clearQueue();
      this.fileUploadProgress.serialImage = null;
      this.selectedSerialImageFile = undefined;
      this.displaySerialImage = undefined;
      this.hoveringFileDrops.serial = false;
      delete this.contentService.uploadSession.filesMap[error.file.name];
    };

    this.serialImageUploader.onAfterAddingFile = (file) => {
      file.withCredentials = false;
      if (file.file.type.startsWith("image/")) {
        this.selectedSerialImageFile = file;
        this.contentService.uploadSession.filesMap[file.file.name] = { file };
        const reader = new FileReader();

        reader.onload = () => {
          this.displaySerialImage = reader.result; // Set the data URL
        };

        reader.onerror = (error) => {
          console.error("Error reading file", error);
        };

        reader.readAsDataURL(file._file); // Read the file as a data URL
      } else {
        alert("Please select an image file");
        this.serialImageUploader.clearQueue();
      }
    };
  }

  reEnterSerial() {
    this.activeModal.close();
    let modalRef = this.appService.showModal(RegisterProductComponent, { size: "lg" });
    modalRef.componentInstance.productKey = this.serial;
  }

  removeSerialImage() {
    this.serialImageUploader.clearQueue();
    this.displaySerialImage = undefined;
    this.selectedSerialImageFile = undefined;
    this.hoveringFileDrops.serial = false;
  }

  public selectedBodyImageFile: any;
  public displayBodyImage: any;
  setupBodyImageUploader() {
    this.bodyImageUploader = new FileUploader({
      isHTML5: true,
      method: "PUT",
      queueLimit: 1,
      autoUpload: false,
      disableMultipart: true,
      url: "",
    });
    this.bodyImageUploader.onProgressAll = (progress: any) => {
      if (this.contentService.uploadSession.filesMap[this.selectedBodyImageFile.file.name]) {
        this.contentService.uploadSession.filesMap[this.selectedBodyImageFile.file.name].progress = progress;
      }
      this.fileUploadProgress.bodyImage = progress < 100 ? progress : null;
    };

    this.bodyImageUploader.onErrorItem = (error: any) => {
      alert("There was an error uploading the body image, please try again.");
      this.bodyImageUploader.clearQueue();
      this.fileUploadProgress.bodyImage = null;
      this.selectedBodyImageFile = undefined;
      this.displayBodyImage = undefined;
      this.hoveringFileDrops.body = false;
    };

    this.bodyImageUploader.onAfterAddingFile = (file) => {
      file.withCredentials = false;
      if (file.file.type.startsWith("image/")) {
        this.selectedBodyImageFile = file;
        this.contentService.uploadSession.filesMap[file.file.name] = { file };
        const reader = new FileReader();

        reader.onload = () => {
          this.displayBodyImage = reader.result; // Set the data URL
        };

        reader.onerror = (error) => {
          console.error("Error reading file", error);
        };

        reader.readAsDataURL(file._file); // Read the file as a data URL
      } else {
        alert("Please select an image file");
        this.bodyImageUploader.clearQueue();
      }
    };
  }

  removeBodyImage() {
    this.bodyImageUploader.clearQueue();
    this.displayBodyImage = undefined;
    this.selectedBodyImageFile = undefined;
    this.hoveringFileDrops.body = false;
  }

  public searchSku() {
    if (this.sku.startsWith("277") || this.sku.startsWith("278") || this.sku.startsWith("279")) {
      this.close();
      this.inelligibleProductEntered.emit("hardware");
      return;
    }
    this.searchingSku = true;
    this.productService.registerFenderProduct(undefined, this.sku).subscribe({
      next: (result: any) => {
        if (result.product?.categoryId && result.product?.categoryId == "software") {
          this.close();
          this.inelligibleProductEntered.emit("software");
        } else {
          this.foundSku = result;
          this.searchingSku = false;
          if (result) {
            this.skuNotFound = false;
            this.unknownSku = false;
          } else {
            this.skuNotFound = true;
          }
        }
      },
      error: (error) => {
        this.skuNotFound = true;
        this.searchingSku = false;
        this.foundSku = undefined;
      },
      complete: () => {
        this.searchingSku = false;
      },
    });
  }

  fileOverBase(e, type) {
    this.hoveringFileDrops[type] = e;
  }

  public registeredMissingSerial: any;
  submit() {
    // Validation: if no SKU found, both images are required
    if (!this.foundSku) {
      if (!this.selectedSerialImageFile || !this.selectedBodyImageFile) {
        alert("Please upload both a photo of the serial number and a photo of your gear.");
        return;
      }
      if (!this.productName || this.productName.trim() === "") {
        alert("Please enter the product name.");
        return;
      }
    }
    this.saving = true;
    this.submitArgs = {
      serial: this.userService.user.id + "#" + this.serial,
      productName: this.productName,
      shopLink: this.shopLink,
      userId: this.user.id,
      category: this.category,
    };

    if (this.foundSku) {
      // SKU found - just register it
      this.submitArgs.sku = this.sku;
      this.productService.saveMissingFenderSerial(this.submitArgs).subscribe((result) => {
        this.productService.getProducts().subscribe((products) => {
          this.registeredMissingSerial = result;
          this.savingComplete = true;
        });
      });
    } else {
      // No SKU found - get presigned URLs sequentially, then upload both files in parallel
      let uploadsCompleted = 0;
      const uploadsNeeded = 2;

      const checkCompletion = () => {
        uploadsCompleted++;
        if (uploadsCompleted === uploadsNeeded) {
          // now save it to dynamo!
          this.productService.saveMissingFenderSerial(this.submitArgs).subscribe((result) => {
            this.productService.getProducts().subscribe((products) => {
              this.saving = false;
              this.registeredMissingSerial = result;
              this.savingComplete = true;
            });
          });
        }
      };

      // Get presigned URL for serial image first
      this.getPresignedURLForSerialImage(() => {
        // Start serial image upload
        this.startSerialImageUpload(checkCompletion);

        // After serial URL request is done, get presigned URL for body image
        this._win.setTimeout(() => {
          this.getPresignedURLForBodyImage(() => {
            // Start body image upload (both uploads happen in parallel)
            this.startBodyImageUpload(checkCompletion);
          });
        }, 200);
      });
    }
  }

  viewGear() {
    this.appService.closeModals();
    let key = this.registeredMissingSerial.sku || "sn-" + this.registeredMissingSerial.serial.split("#")[1].toUpperCase();
    this._router.navigate(["/products/detail/", key]);
  }

  getPresignedURLForSerialImage(onComplete: () => void) {
    this.contentService
      .getPresignedUploadURL({
        folder: `missing-fender-serials/${this.user.id}/${this.serial}/serial-image`,
        fileName: this.selectedSerialImageFile.file.name,
        type: "generic_file",
      })
      .subscribe((result) => {
        if (result.file) {
          this.submitArgs.serialImageUrl = result.file.url;
          this.contentService.uploadSession.filesMap[result.file.fileName].paeEntity = result.file;
          this.serialImageUploader.queue.forEach((file) => {
            let uploadHeaders = [];
            uploadHeaders.push({ name: "Content-Type", value: undefined });
            uploadHeaders.push({ name: "Content-Disposition", value: 'attachment; filename="' + this.selectedSerialImageFile.file.name + '"' });
            file.headers = uploadHeaders;
            file.url = result.url;
          });
          onComplete();
        } else {
          this.fileUploadProgress.serialImage = null;
          this.removeImage("serialImage");
          alert("There was an error getting upload URL for the serial image, please try again.");
          onComplete();
        }
      });
  }

  startSerialImageUpload(onComplete: () => void) {
    this.serialImageUploader.queue.forEach((file) => {
      file.onComplete = () => onComplete();
      this.serialImageUploader.uploadItem(file);
    });
  }

  getPresignedURLForBodyImage(onComplete: () => void) {
    this.contentService
      .getPresignedUploadURL({
        folder: `missing-fender-serials/${this.user.id}/${this.serial}/body-image`,
        fileName: this.selectedBodyImageFile.file.name,
        type: "generic_file",
      })
      .subscribe((result) => {
        if (result.file) {
          this.submitArgs.bodyImageUrl = result.file.url;
          this.contentService.uploadSession.filesMap[result.file.fileName].paeEntity = result.file;
          this.bodyImageUploader.queue.forEach((file) => {
            let uploadHeaders = [];
            uploadHeaders.push({ name: "Content-Type", value: undefined });
            uploadHeaders.push({ name: "Content-Disposition", value: 'attachment; filename="' + this.selectedBodyImageFile.file.name + '"' });
            file.headers = uploadHeaders;
            file.url = result.url;
          });
          onComplete();
        } else {
          this.fileUploadProgress.bodyImage = null;
          this.removeImage("bodyImage");
          alert("There was an error getting upload URL for the body image, please try again.");
          onComplete();
        }
      });
  }

  startBodyImageUpload(onComplete: () => void) {
    this.bodyImageUploader.queue.forEach((file) => {
      file.onComplete = () => onComplete();
      this.bodyImageUploader.uploadItem(file);
    });
  }

  removeImage(type) {
    if (type == "serialImage") {
      this.displaySerialImage = null;
      this.selectedSerialImageFile = null;
      this.serialImageUploader.clearQueue();
      // delete args.serialImageUrl;
    } else if (type == "bodyImage") {
      this.displayBodyImage = null;
      this.selectedBodyImageFile = null;
      this.bodyImageUploader.clearQueue();
      // delete args.bodyImageUrl;
    }
  }

  close() {
    this.activeModal.close();
  }
}
